"use client";

import React from "react";
import { ComponentConfig } from "@puckeditor/core";
import Link from "next/link";

export interface CTABandProps {
  heading?: string;
  subheading?: string;
  buttonText?: string;
  buttonLink?: string;
}

export const CTABandBlock: ComponentConfig<CTABandProps> = {
  label: "CTA Band Section",
  fields: {
    heading: { type: "text", label: "Heading" },
    subheading: { type: "textarea", label: "Subheading" },
    buttonText: { type: "text", label: "Button Text" },
    buttonLink: { type: "text", label: "Button Route Link" },
  },
  defaultProps: {
    heading: "Ready to Formulate Your Next Hero Product?",
    subheading: "Share your intended product, benchmark, packaging direction, target market, and batch quantity for a structured technical review.",
    buttonText: "Start Your Product Inquiry",
    buttonLink: "/contact",
  },
  render: ({ heading, subheading, buttonText, buttonLink }) => {
    return (
      <section className="cta-band">
        <div className="container cta-inner">
          <h2>{heading}</h2>
          <p>{subheading}</p>
          <Link className="btn btn-light" href={buttonLink || "/contact"}>
            {buttonText}{" "}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </section>
    );
  },
};
